// Mock data for WhaTap Indonesia Partner Website

export const heroData = {
  title: "Platform Observability AI-Native",
  subtitle: "Kuasai kompleksitas operasi berbasis AI",
  description: "Dapatkan visibilitas penuh dengan Platform Observability WhaTap. Monitoring GPU, aplikasi, Kubernetes, server, dan database dalam satu platform.",
  cta: {
    primary: "Hubungi Sales",
    secondary: "Minta Demo"
  }
};

export const services = [
  {
    id: 1,
    title: "GPU Monitoring",
    description: "GPU sangat penting tetapi kompleks untuk dioperasikan. WhaTap memberikan visibilitas real-time untuk manajemen sumber daya yang lebih cerdas.",
    icon: "Cpu",
    features: ["Real-time monitoring", "Resource optimization", "Performance analytics"]
  },
  {
    id: 2,
    title: "Kubernetes",
    description: "Identifikasi akar masalah dengan cepat dengan mengumpulkan metrik, trace, dan log real-time melalui Container Map.",
    icon: "Container",
    features: ["Container mapping", "Real-time metrics", "Log aggregation"]
  },
  {
    id: 3,
    title: "Application Monitoring",
    description: "Identifikasi bottleneck dengan cepat dengan visibilitas granular terhadap performa aplikasi Anda.",
    icon: "Code",
    features: ["Java", "Node.js", "Python", "PHP", "Go"]
  },
  {
    id: 4,
    title: "Database Monitoring",
    description: "Pastikan ketersediaan dan performa konsisten melalui monitoring, diagnostik, dan analisis real-time.",
    icon: "Database",
    features: ["Query analysis", "Performance tuning", "Real-time alerts"]
  },
  {
    id: 5,
    title: "Server Monitoring",
    description: "Dioptimalkan untuk monitoring terpadu berbasis cloud, memungkinkan manajemen kesehatan sistem secara menyeluruh.",
    icon: "Server",
    features: ["Multi-cloud support", "System health", "Resource tracking"]
  },
  {
    id: 6,
    title: "Network Performance",
    description: "Monitor performa jaringan dan identifikasi masalah sebelum berdampak pada pengguna.",
    icon: "Network",
    features: ["Latency tracking", "Traffic analysis", "Bottleneck detection"]
  }
];

export const features = [
  {
    number: "01",
    title: "Layanan SaaS",
    description: "Solusi SaaS all-in-one yang menyediakan setiap fungsi penting untuk monitoring IT."
  },
  {
    number: "02",
    title: "Monitoring Terpadu",
    description: "Monitor berbagai layanan dengan mulus melalui satu platform terpadu dengan WhaTap."
  },
  {
    number: "03",
    title: "Visibilitas Real-Time",
    description: "Segera nilai status saat ini dan analisis data historis dalam sekejap mata."
  },
  {
    number: "04",
    title: "Teknologi Terdepan",
    description: "Memanfaatkan teknologi terkini dan data kontekstual untuk memberikan insight yang dapat ditindaklanjuti."
  },
  {
    number: "05",
    title: "Enkripsi Data",
    description: "Semua data dienkripsi saat penyimpanan, memastikan keamanan dan ketenangan pikiran sepenuhnya."
  },
  {
    number: "06",
    title: "Monitoring Intuitif",
    description: "Identifikasi masalah dengan cepat dengan tampilan single-pane yang menyoroti metrik penting."
  }
];

export const customerStories = [
  {
    id: 1,
    company: "PT Weefer Indonesia",
    title: "Meningkatkan Performa SLA sebesar 50% dengan WhaTap",
    description: "Weefer Indonesia berhasil meningkatkan performa SLA mereka hingga 50% setelah mengimplementasikan WhaTap untuk monitoring infrastruktur mereka.",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&h=600&fit=crop",
    results: [
      "50% peningkatan SLA",
      "70% pengurangan waktu downtime",
      "Real-time monitoring"
    ]
  },
  {
    id: 2,
    company: "Smartfren",
    title: "Mendukung 36 Juta Pengguna dengan WhaTap",
    description: "Smartfren beralih dari open source ke WhaTap untuk mendukung infrastruktur yang melayani 36 juta pengguna aktif.",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=600&fit=crop",
    results: [
      "36 juta pengguna didukung",
      "Monitoring terpadu",
      "Peningkatan stabilitas sistem"
    ]
  },
  {
    id: 3,
    company: "Adira Finance",
    title: "Pengurangan Biaya 50% dan Stabilitas Sistem Meningkat",
    description: "Adira Finance mencapai pengurangan biaya operasional hingga 50% sambil meningkatkan stabilitas sistem dengan WhaTap.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop",
    results: [
      "50% pengurangan biaya",
      "Stabilitas sistem meningkat",
      "Monitoring proaktif"
    ]
  },
  {
    id: 4,
    company: "Klik Indomaret",
    title: "80% Waktu Respons Lebih Cepat dengan WhaTap",
    description: "Klik Indomaret mencapai peningkatan waktu respons hingga 80% lebih cepat dalam menangani masalah sistem.",
    image: "https://images.unsplash.com/photo-1556742502-ec7c0e9f34b1?w=800&h=600&fit=crop",
    results: [
      "80% waktu respons lebih cepat",
      "Deteksi masalah otomatis",
      "Efisiensi operasional"
    ]
  }
];

export const certifications = [
  {
    name: "Gartner Market Guide",
    description: "Satu-satunya vendor Korea yang diakui dalam Gartner® Market Guide 2025"
  },
  {
    name: "ISO 27001",
    description: "Sertifikasi standar internasional untuk sistem manajemen keamanan informasi"
  },
  {
    name: "ISO 27017",
    description: "Sertifikasi untuk sistem manajemen perlindungan informasi layanan Cloud"
  },
  {
    name: "AWS Partner",
    description: "AWS Software Pass dan AWS Qualified Software"
  }
];

export const stats = [
  {
    value: "15,000+",
    label: "Perusahaan Global"
  },
  {
    value: "99.9%",
    label: "Uptime Terjamin"
  },
  {
    value: "24/7",
    label: "Support"
  },
  {
    value: "50+",
    label: "Integrasi"
  }
];

export const testimonials = [
  {
    quote: "WhaTap membantu kami mengidentifikasi dan menyelesaikan masalah sebelum pelanggan kami menyadarinya.",
    author: "Head of IT Operations",
    company: "PT Weefer Indonesia"
  },
  {
    quote: "Monitoring terpadu dari WhaTap memungkinkan tim kami untuk fokus pada inovasi, bukan firefighting.",
    author: "CTO",
    company: "Smartfren"
  },
  {
    quote: "ROI dari implementasi WhaTap tercapai dalam 3 bulan pertama. Luar biasa!",
    author: "Director of Technology",
    company: "Adira Finance"
  }
];

export const pricingPlans = [
  {
    name: "Starter",
    description: "Untuk tim kecil yang baru memulai",
    price: "Hubungi Sales",
    features: [
      "Hingga 10 host",
      "Retensi data 7 hari",
      "Email support",
      "Dashboard dasar",
      "Alerting dasar"
    ]
  },
  {
    name: "Professional",
    description: "Untuk bisnis yang berkembang",
    price: "Hubungi Sales",
    popular: true,
    features: [
      "Hingga 100 host",
      "Retensi data 30 hari",
      "Priority support 24/7",
      "Advanced dashboard",
      "Custom alerting",
      "API access",
      "Integrasi unlimited"
    ]
  },
  {
    name: "Enterprise",
    description: "Untuk perusahaan besar",
    price: "Custom",
    features: [
      "Unlimited hosts",
      "Retensi data custom",
      "Dedicated support",
      "White-label dashboard",
      "Advanced security",
      "SLA 99.9%",
      "On-premise option",
      "Custom integration"
    ]
  }
];

export const contactInfo = {
  email: "info@vamosds.com",
  address: "Sudirman 7.8 Tower Level 16 Unit 1&2, Jl. Jend. Sudirman Kav. 7-8 RT. 010 RW. 011, Jakarta Pusat, DKI Jakarta - 10220",
  social: {
    linkedin: "https://www.linkedin.com/company/whataplabs/",
    facebook: "https://www.facebook.com/whatap.io",
    youtube: "https://www.youtube.com/@whatapglobal"
  }
};
